import { render } from "./PurchaseTable.vue?vue&type=template&id=1a93d9fc&scoped=true&ts=true&lang=pug"
import script from "./PurchaseTable.vue?vue&type=script&lang=ts"
export * from "./PurchaseTable.vue?vue&type=script&lang=ts"

import "./PurchaseTable.vue?vue&type=style&index=0&id=1a93d9fc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a93d9fc"]])

export default __exports__